import styled from 'styled-components';

export const InformationCard = styled.div`
  border: 1px solid var(--border);
  border-radius: 6px;
  background-color: var(--background);
`;

export const Header = styled.div`
  padding: 12px;
`;

export const Divider = styled.div`
  width: 100%;
  border-top: 1px solid var(--border);
  margin-bottom: 12px;
`;

export const Content = styled.div`
  padding: 0 12px 16px 12px;
`;
